import { CService } from "./class.base.service";

class ActionService extends CService{
  saveInvoices(action_id:string|number, params:FormData){
    return this.api.post(`/${this.path}/${action_id}/invoices`,params);
  }
  saveProofPerformances(action_id:string|number, params:FormData){
    return this.api.post(`/${this.path}/${action_id}/proof_performances`,params);
  }
  getCategories<T = any>(params?: any):Promise<T>{
    return this.api.get<any, T>(`action-categories`,params);
  }
  getSubcategories<T = any>(params?: any):Promise<T>{
    return this.api.get<any, T>(`action-subcategories`,params);
  }
  getQuantitiesOnMonthsByYear<T = any>(year:number | string,params?: any):Promise<T>{
    return this.api.get<any, T>(`/${this.path}/quantities-on-months-by-year/${year}`,params);
  }
  linkPlan(action_id:string|number, plan_id:string|number){
    return this.api.post(`/${this.path}/link-plan/${action_id}/${plan_id}`);
  }
  linkReceive(action_id:string|number, receive_id:string|number){
    return this.api.post(`/${this.path}/link-receive/${action_id}/${receive_id}`);
  }
  moveMonth(action_id:string|number, date:string){
    let fd = new FormData();
    fd.append("date",date);
    return this.api.postLoad(`/${this.path}/move-month/${action_id}/`,fd);
  }
}

const actionService = new ActionService("actions");
export default actionService;